import { Component, input } from '@angular/core';
import { YesNoIconComponent } from '@rocksoft/cdk';
import { AppleDeviceProfile } from '../../../viewmodels/apple/apple-profiles.model';

@Component({
  selector: 'ml-mdm-apple-profile',
  templateUrl: './apple-profile.component.html',
  styleUrls: ['./apple-profile.component.scss'],
  imports: [YesNoIconComponent],
})
export class AppleProfileComponent {
  public readonly profile = input<AppleDeviceProfile>();
}
